import { CheckIcon } from "@heroicons/react/24/solid";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

import { phoneSupport } from "@/constants";

interface BuyPremiumConsultancyProps {
  children: React.ReactNode;
}

export const BuyPremiumConsultancy = ({
  children,
}: BuyPremiumConsultancyProps) => {
  const openWhatsApp = () => {
    window.open(
      `https://wa.me/${phoneSupport}?text=Olá,%20tenho%20interesse%20na%20consultoria%20premium%20para%20leilões.`,
      "_blank"
    );
  };

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent aria-describedby={undefined} className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Consultoria Premium</DialogTitle>
          <DialogDescription>
            Análise especializada para investimentos em leilões
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-8 py-4">
          <div className="flex flex-col gap-4">
            <h4 className="font-medium text-sm">O que oferecemos:</h4>
            <ul className="text-sm flex flex-col gap-4">
              <li className="flex items-start gap-2">
                <div className="rounded-full bg-green-500 p-1 mt-0.5">
                  <CheckIcon className="h-3 w-3 text-white" />
                </div>
                <span>
                  <strong>Análise de Dívidas</strong>: Identificação de dívidas
                  ocultas e débitos propter rem que podem afetar o valor real do
                  imóvel
                </span>
              </li>
              <li className="flex items-start gap-2">
                <div className="rounded-full bg-green-500 p-1 mt-0.5">
                  <CheckIcon className="h-3 w-3 text-white" />
                </div>
                <span>
                  <strong>Verificação Documental</strong>: Revisão completa da
                  documentação do leilão para evitar problemas jurídicos
                </span>
              </li>
              <li className="flex items-start gap-2">
                <div className="rounded-full bg-green-500 p-1 mt-0.5">
                  <CheckIcon className="h-3 w-3 text-white" />
                </div>
                <span>
                  <strong>Avaliação de Riscos</strong>: Identificação de
                  pendências judiciais e administrativas
                </span>
              </li>
              <li className="flex items-start gap-2">
                <div className="rounded-full bg-green-500 p-1 mt-0.5">
                  <CheckIcon className="h-3 w-3 text-white" />
                </div>
                <span>
                  <strong>Estratégia de Aquisição</strong>: Recomendações
                  personalizadas para maximizar seu ROI
                </span>
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-2">
            <h4 className="font-medium text-sm">Por que contratar:</h4>
            <p className="text-sm text-muted-foreground">
              Imóveis em leilão frequentemente possuem contingências ocultas que
              reduzem significativamente a margem de lucro ou até geram
              prejuízos. Nossa consultoria premium identifica esses riscos antes
              da aquisição.
            </p>
          </div>
          <div className="border rounded-lg p-3 bg-muted/50">
            <div className="flex items-center">
              <div>
                <h4 className="font-medium">Consultoria Completa</h4>
                <p className="text-sm text-muted-foreground">
                  Análise detalhada + relatório personalizado
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            onClick={openWhatsApp}
            className="bg-green-600 hover:bg-green-700 w-full"
          >
            <ChatBubbleLeftRightIcon
              aria-hidden="true"
              className="h-4 w-4 mr-2"
            />
            Quero contratar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
